import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-raleway';
import { Provider } from "react-redux";
import { store } from './store/index';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
document.title = 'Orders';
ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
